var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"id":"price-search","menu-class":"advanced-dropdown","text":"Bérleti díj"}},[_c('price-search-form',{attrs:{"url":_vm.url,"commercial":_vm.commercial,"min_price":_vm.min_price,"max_price":_vm.max_price}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }